// TODO Add a couple lines about each project
const data = [
  {
    title: 'Nearest Dollar',
    subtitle: '2015 BVP Hackathon',
    image: '/images/projects/nearestdollar.jpg',
    date: '2015-11-20',
    desc:
      'Built for a social impact hackathon. '
      + 'NearestDollar connected to your bank accounts, credit cards, '
      + 'or debit cards and rounded up your purchases to donate the balance to '
      + 'the charity of your choice.',
  },
  {
    title: 'Harvest',
    subtitle: 'Won 3rd. place in 2015 Techcrunch Disrupt SF Hackathon',
    link: 'https://devpost.com/software/harvest',
    image: '/images/projects/harvest.jpg',
    date: '2015-09-20',
    desc:
      'Won ~ $7000 in prizes for an advanced, low cost monitoring solution '
      + 'for crops. Harvest was designed to catch irrigation leaks, overwatering, '
      + 'and nutrient deficiencies at an affordable price for the developing world.',
  },
  {
    title: 'Space Potato',
    subtitle: 'A kickstarter funded potato powered weather balloon.',
    link: 'http://www.spacepotato.org',
    image: '/images/projects/spacepotato.jpg',
    date: '2015-06-28',
    desc:
      'Launched a potato battery powered weather balloon with two cameras '
      + 'and gps transponder. Resulting photos were published in a coffee table book. '
      + 'You can email me for a copy.',
  },
  {
    title: 'Cat Detector',
    subtitle: 'A convolutional neural network to classify cats! (and dogs)',
    image: '/images/projects/catdetector.jpg',
    date: '2015-05-15',
    desc:
      'Trained a convolutional neural network to classify between ~ 80 cats breeds. '
      + 'Over 60,000 cats were classified before server bills made the project too expensive '
      + 'to continue hosting.',
  },
];

export default data;
